import { memo } from 'react';
import CONFIG from 'src/utils/config';
import { AppBrands } from 'src/utils/constants';
import CartInclusive, { CartInclusiveProps } from './CartInclusive';
import Cart, { CartProps } from './Cart';

export const CartWrapper = memo((props: CartProps & CartInclusiveProps) => {
    const brand = CONFIG.APP_BRAND;

    if (brand === AppBrands.BREKR) {
        return <CartInclusive {...props} />;
    }

    return <Cart {...props} />;
});
